<template>
  <div class="filter-panel-wrapper" :class="{ 'is-mobile': isMobile }">
    <h4 v-if="totalCount" class="color-gray" :class="{ 'mt-15': isMobile }">{{ totalCount }} TOTAL RESULTS</h4>

    <filter-accordion
      v-if="!hideFilter($utils.constants.FilterKeys.CATEGORIES)"
      :label="getParentCategoryFilter() ? 'Subcategories' : 'Categories'"
      :filter-key="$utils.constants.FilterKeys.CATEGORIES"
      :active-filter-key="openedFilter"
      :on-change="handleAccordionStateChange"
    >
      <filter-categories-new
        :parent-category-filter="getParentCategoryFilter()"
        :categories-filter="getBrandCategoryFilter()"
        :pre-loaded-categories="getCategories()"
      />
    </filter-accordion>

    <filter-accordion
      v-if="!hideFilter($utils.constants.FilterKeys.BRANDS)"
      label="Brands"
      :filter-key="$utils.constants.FilterKeys.BRANDS"
      :active-filter-key="openedFilter"
      :on-change="handleAccordionStateChange"
    >
      <filter-brand-new />
    </filter-accordion>

    <filter-accordion
      v-if="!hideFilter($utils.constants.FilterKeys.BRAND_VALUES)"
      label="Brand values"
      :filter-key="$utils.constants.FilterKeys.BRAND_VALUES"
      :active-filter-key="openedFilter"
      :on-change="handleAccordionStateChange"
    >
      <filter-brand-values-new />
    </filter-accordion>

    <filter-accordion
      v-if="!hideFilter($utils.constants.FilterKeys.PRICE_FROM)"
      label="Retail Price"
      no-search
      :content-height="330"
      :filter-key="$utils.constants.FilterKeys.PRICE_FROM"
      :active-filter-key="openedFilter"
      :on-change="handleAccordionStateChange"
    >
      <filter-price-new />
    </filter-accordion>

    <filter-accordion
      v-if="!hideFilter($utils.constants.FilterKeys.SHIP_BY)"
      label="Ship by"
      no-search
      :content-height="330"
      :filter-key="$utils.constants.FilterKeys.SHIP_BY"
      :active-filter-key="openedFilter"
      :on-change="handleAccordionStateChange"
    >
      <filter-date-new />
    </filter-accordion>

    <filter-accordion
      v-if="!hideFilter($utils.constants.FilterKeys.LOCATION)"
      label="Location"
      :filter-key="$utils.constants.FilterKeys.LOCATION"
      :active-filter-key="openedFilter"
      :on-change="handleAccordionStateChange"
    >
      <filter-locations />
    </filter-accordion>

    <filter-accordion
      v-if="!hideFilter($utils.constants.FilterKeys.MOV)"
      label="Minimum Order"
      no-search
      :content-height="350"
      :filter-key="$utils.constants.FilterKeys.MOV"
      :active-filter-key="openedFilter"
      :on-change="handleAccordionStateChange"
    >
      <filter-minimum-order-value-new />
    </filter-accordion>
  </div>
</template>

<style lang="scss" scoped>
.filter-panel-wrapper {
  width: calc(25% - 10px);
  &.is-mobile {
    max-width: 100%;
    width: 100%;
  }
}
</style>

<script>
import FilterBrandValuesNew from "./filterTypes/filterBrandValues";
import { FilterKeys } from "../../../services/utils";
export default {
  components: { FilterBrandValuesNew },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    totalCount: {
      type: Number,
      default: 0,
    },
    filterPanelConfig: {
      type: Object,
      default: function () {
        // Shape of filter panel config
        return {
          hiddenFilters: [],
          filterSettings: {
            [FilterKeys.CATEGORIES]: {
              parentCategoryId: "",
              brandCategories: [
                {
                  parent_category: "", // name of the parent category
                  child_categories: [], // names of the sub categories
                },
              ],
            },
          },
        };
      },
    },
  },
  data() {
    return { openedFilter: null };
  },
  methods: {
    handleAccordionStateChange: function ({ open, filterKey }) {
      if (!open) {
        this.openedFilter = null;
        return;
      }

      this.openedFilter = filterKey;
    },
    hideFilter: function (filterKey) {
      return this.filterPanelConfig?.hiddenFilters?.includes(filterKey.toString());
    },
    getParentCategoryFilter: function () {
      const { filterSettings } = this.filterPanelConfig;
      return filterSettings ? filterSettings[FilterKeys.CATEGORIES]?.parentCategoryId : undefined;
    },
    getBrandCategoryFilter: function () {
      const { filterSettings } = this.filterPanelConfig;
      return filterSettings ? filterSettings[FilterKeys.CATEGORIES]?.categoriesFilter : [];
    },
    getCategories: function () {
      const { filterSettings } = this.filterPanelConfig || {};
      return filterSettings ? filterSettings[FilterKeys.CATEGORIES]?.categories : undefined;
    },
  },
};
</script>
